var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 413,
    height: 505,
    viewBox: "0 0 413 505",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88615 0.00244141C1.73972 0.00244141 -9.15527e-05 1.63694 -9.15527e-05 3.65344C-9.15527e-05 5.66944 1.73972 7.30444 3.88615 7.30444C6.03258 7.30444 7.7724 5.66944 7.7724 3.65344C7.7724 1.63694 6.03258 0.00244141 3.88615 0.00244141",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88615 31.6855C1.73972 31.6855 -9.15527e-05 33.32 -9.15527e-05 35.3365C-9.15527e-05 37.3525 1.73972 38.9875 3.88615 38.9875C6.03258 38.9875 7.7724 37.3525 7.7724 35.3365C7.7724 33.32 6.03258 31.6855 3.88615 31.6855",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88615 63.3687C1.73972 63.3687 -9.15527e-05 65.0032 -9.15527e-05 67.0197C-9.15527e-05 69.0362 1.73972 70.6707 3.88615 70.6707C6.03258 70.6707 7.7724 69.0362 7.7724 67.0197C7.7724 65.0032 6.03258 63.3687 3.88615 63.3687",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88615 95.0518C1.73972 95.0518 -9.15527e-05 96.6868 -9.15527e-05 98.7028C-9.15527e-05 100.719 1.73972 102.354 3.88615 102.354C6.03258 102.354 7.7724 100.719 7.7724 98.7028C7.7724 96.6868 6.03258 95.0518 3.88615 95.0518",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88615 126.735C1.73972 126.735 -9.15527e-05 128.37 -9.15527e-05 130.386C-9.15527e-05 132.402 1.73972 134.037 3.88615 134.037C6.03258 134.037 7.7724 132.402 7.7724 130.386C7.7724 128.37 6.03258 126.735 3.88615 126.735",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88615 158.418C1.73972 158.418 -9.15527e-05 160.053 -9.15527e-05 162.069C-9.15527e-05 164.086 1.73972 165.72 3.88615 165.72C6.03258 165.72 7.7724 164.086 7.7724 162.069C7.7724 160.053 6.03258 158.418 3.88615 158.418",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88615 190.101C1.73972 190.101 -9.15527e-05 191.736 -9.15527e-05 193.752C-9.15527e-05 195.769 1.73972 197.403 3.88615 197.403C6.03258 197.403 7.7724 195.769 7.7724 193.752C7.7724 191.736 6.03258 190.101 3.88615 190.101",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88615 221.784C1.73972 221.784 -9.15527e-05 223.419 -9.15527e-05 225.435C-9.15527e-05 227.452 1.73972 229.086 3.88615 229.086C6.03258 229.086 7.7724 227.452 7.7724 225.435C7.7724 223.419 6.03258 221.784 3.88615 221.784",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88615 253.468C1.73972 253.468 -9.15527e-05 255.103 -9.15527e-05 257.119C-9.15527e-05 259.135 1.73972 260.77 3.88615 260.77C6.03258 260.77 7.7724 259.135 7.7724 257.119C7.7724 255.103 6.03258 253.468 3.88615 253.468",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88615 285.151C1.73972 285.151 -9.15527e-05 286.786 -9.15527e-05 288.802C-9.15527e-05 290.818 1.73972 292.453 3.88615 292.453C6.03258 292.453 7.7724 290.818 7.7724 288.802C7.7724 286.786 6.03258 285.151 3.88615 285.151",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88615 316.834C1.73972 316.834 -9.15527e-05 318.469 -9.15527e-05 320.485C-9.15527e-05 322.501 1.73972 324.136 3.88615 324.136C6.03258 324.136 7.7724 322.501 7.7724 320.485C7.7724 318.469 6.03258 316.834 3.88615 316.834",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88615 348.517C1.73972 348.517 -9.15527e-05 350.152 -9.15527e-05 352.168C-9.15527e-05 354.184 1.73972 355.819 3.88615 355.819C6.03258 355.819 7.7724 354.184 7.7724 352.168C7.7724 350.152 6.03258 348.517 3.88615 348.517",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88615 380.2C1.73972 380.2 -9.15527e-05 381.835 -9.15527e-05 383.851C-9.15527e-05 385.868 1.73972 387.502 3.88615 387.502C6.03258 387.502 7.7724 385.868 7.7724 383.851C7.7724 381.835 6.03258 380.2 3.88615 380.2",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88615 411.884C1.73972 411.884 -9.15527e-05 413.519 -9.15527e-05 415.535C-9.15527e-05 417.551 1.73972 419.186 3.88615 419.186C6.03258 419.186 7.7724 417.551 7.7724 415.535C7.7724 413.519 6.03258 411.884 3.88615 411.884",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88615 443.567C1.73972 443.567 -9.15527e-05 445.202 -9.15527e-05 447.218C-9.15527e-05 449.234 1.73972 450.869 3.88615 450.869C6.03258 450.869 7.7724 449.234 7.7724 447.218C7.7724 445.202 6.03258 443.567 3.88615 443.567",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88615 470.25C1.73972 470.25 -9.15527e-05 471.885 -9.15527e-05 473.901C-9.15527e-05 475.917 1.73972 477.552 3.88615 477.552C6.03258 477.552 7.7724 475.917 7.7724 473.901C7.7724 471.885 6.03258 470.25 3.88615 470.25",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88615 496.933C1.73972 496.933 -9.15527e-05 498.568 -9.15527e-05 500.584C-9.15527e-05 502.6 1.73972 504.235 3.88615 504.235C6.03258 504.235 7.7724 502.6 7.7724 500.584C7.7724 498.568 6.03258 496.933 3.88615 496.933",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6109 0.00244141C35.4645 0.00244141 33.7247 1.63694 33.7247 3.65344C33.7247 5.66944 35.4645 7.30444 37.6109 7.30444C39.7574 7.30444 41.4972 5.66944 41.4972 3.65344C41.4972 1.63694 39.7574 0.00244141 37.6109 0.00244141",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6109 31.6855C35.4645 31.6855 33.7247 33.32 33.7247 35.3365C33.7247 37.3525 35.4645 38.9875 37.6109 38.9875C39.7574 38.9875 41.4972 37.3525 41.4972 35.3365C41.4972 33.32 39.7574 31.6855 37.6109 31.6855",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6109 63.3687C35.4645 63.3687 33.7247 65.0032 33.7247 67.0197C33.7247 69.0362 35.4645 70.6707 37.6109 70.6707C39.7574 70.6707 41.4972 69.0362 41.4972 67.0197C41.4972 65.0032 39.7574 63.3687 37.6109 63.3687",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6109 95.0518C35.4645 95.0518 33.7247 96.6868 33.7247 98.7028C33.7247 100.719 35.4645 102.354 37.6109 102.354C39.7574 102.354 41.4972 100.719 41.4972 98.7028C41.4972 96.6868 39.7574 95.0518 37.6109 95.0518",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6109 126.735C35.4645 126.735 33.7247 128.37 33.7247 130.386C33.7247 132.402 35.4645 134.037 37.6109 134.037C39.7574 134.037 41.4972 132.402 41.4972 130.386C41.4972 128.37 39.7574 126.735 37.6109 126.735",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6109 158.418C35.4645 158.418 33.7247 160.053 33.7247 162.069C33.7247 164.086 35.4645 165.72 37.6109 165.72C39.7574 165.72 41.4972 164.086 41.4972 162.069C41.4972 160.053 39.7574 158.418 37.6109 158.418",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6109 190.101C35.4645 190.101 33.7247 191.736 33.7247 193.752C33.7247 195.769 35.4645 197.403 37.6109 197.403C39.7574 197.403 41.4972 195.769 41.4972 193.752C41.4972 191.736 39.7574 190.101 37.6109 190.101",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6109 221.784C35.4645 221.784 33.7247 223.419 33.7247 225.435C33.7247 227.452 35.4645 229.086 37.6109 229.086C39.7574 229.086 41.4972 227.452 41.4972 225.435C41.4972 223.419 39.7574 221.784 37.6109 221.784",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6109 253.468C35.4645 253.468 33.7247 255.103 33.7247 257.119C33.7247 259.135 35.4645 260.77 37.6109 260.77C39.7574 260.77 41.4972 259.135 41.4972 257.119C41.4972 255.103 39.7574 253.468 37.6109 253.468",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6109 285.151C35.4645 285.151 33.7247 286.786 33.7247 288.802C33.7247 290.818 35.4645 292.453 37.6109 292.453C39.7574 292.453 41.4972 290.818 41.4972 288.802C41.4972 286.786 39.7574 285.151 37.6109 285.151",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6109 316.834C35.4645 316.834 33.7247 318.469 33.7247 320.485C33.7247 322.501 35.4645 324.136 37.6109 324.136C39.7574 324.136 41.4972 322.501 41.4972 320.485C41.4972 318.469 39.7574 316.834 37.6109 316.834",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6109 348.517C35.4645 348.517 33.7247 350.152 33.7247 352.168C33.7247 354.184 35.4645 355.819 37.6109 355.819C39.7574 355.819 41.4972 354.184 41.4972 352.168C41.4972 350.152 39.7574 348.517 37.6109 348.517",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6109 380.2C35.4645 380.2 33.7247 381.835 33.7247 383.851C33.7247 385.868 35.4645 387.502 37.6109 387.502C39.7574 387.502 41.4972 385.868 41.4972 383.851C41.4972 381.835 39.7574 380.2 37.6109 380.2",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6109 411.884C35.4645 411.884 33.7247 413.519 33.7247 415.535C33.7247 417.551 35.4645 419.186 37.6109 419.186C39.7574 419.186 41.4972 417.551 41.4972 415.535C41.4972 413.519 39.7574 411.884 37.6109 411.884",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6109 443.567C35.4645 443.567 33.7247 445.202 33.7247 447.218C33.7247 449.234 35.4645 450.869 37.6109 450.869C39.7574 450.869 41.4972 449.234 41.4972 447.218C41.4972 445.202 39.7574 443.567 37.6109 443.567",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6109 470.25C35.4645 470.25 33.7247 471.885 33.7247 473.901C33.7247 475.917 35.4645 477.552 37.6109 477.552C39.7574 477.552 41.4972 475.917 41.4972 473.901C41.4972 471.885 39.7574 470.25 37.6109 470.25",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6109 496.933C35.4645 496.933 33.7247 498.568 33.7247 500.584C33.7247 502.6 35.4645 504.235 37.6109 504.235C39.7574 504.235 41.4972 502.6 41.4972 500.584C41.4972 498.568 39.7574 496.933 37.6109 496.933",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3355 0.00244141C69.1891 0.00244141 67.4492 1.63694 67.4492 3.65344C67.4492 5.66944 69.1891 7.30444 71.3355 7.30444C73.4819 7.30444 75.2217 5.66944 75.2217 3.65344C75.2217 1.63694 73.4819 0.00244141 71.3355 0.00244141",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3355 31.6855C69.1891 31.6855 67.4492 33.32 67.4492 35.3365C67.4492 37.3525 69.1891 38.9875 71.3355 38.9875C73.4819 38.9875 75.2217 37.3525 75.2217 35.3365C75.2217 33.32 73.4819 31.6855 71.3355 31.6855",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3355 63.3687C69.1891 63.3687 67.4492 65.0032 67.4492 67.0197C67.4492 69.0362 69.1891 70.6707 71.3355 70.6707C73.4819 70.6707 75.2217 69.0362 75.2217 67.0197C75.2217 65.0032 73.4819 63.3687 71.3355 63.3687",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3355 95.0518C69.1891 95.0518 67.4492 96.6868 67.4492 98.7028C67.4492 100.719 69.1891 102.354 71.3355 102.354C73.4819 102.354 75.2217 100.719 75.2217 98.7028C75.2217 96.6868 73.4819 95.0518 71.3355 95.0518",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3355 126.735C69.1891 126.735 67.4492 128.37 67.4492 130.386C67.4492 132.402 69.1891 134.037 71.3355 134.037C73.4819 134.037 75.2217 132.402 75.2217 130.386C75.2217 128.37 73.4819 126.735 71.3355 126.735",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3355 158.418C69.1891 158.418 67.4492 160.053 67.4492 162.069C67.4492 164.086 69.1891 165.72 71.3355 165.72C73.4819 165.72 75.2217 164.086 75.2217 162.069C75.2217 160.053 73.4819 158.418 71.3355 158.418",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3355 190.101C69.1891 190.101 67.4492 191.736 67.4492 193.752C67.4492 195.769 69.1891 197.403 71.3355 197.403C73.4819 197.403 75.2217 195.769 75.2217 193.752C75.2217 191.736 73.4819 190.101 71.3355 190.101",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3355 221.784C69.1891 221.784 67.4492 223.419 67.4492 225.435C67.4492 227.452 69.1891 229.086 71.3355 229.086C73.4819 229.086 75.2217 227.452 75.2217 225.435C75.2217 223.419 73.4819 221.784 71.3355 221.784",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3355 253.468C69.1891 253.468 67.4492 255.103 67.4492 257.119C67.4492 259.135 69.1891 260.77 71.3355 260.77C73.4819 260.77 75.2217 259.135 75.2217 257.119C75.2217 255.103 73.4819 253.468 71.3355 253.468",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3355 285.151C69.1891 285.151 67.4492 286.786 67.4492 288.802C67.4492 290.818 69.1891 292.453 71.3355 292.453C73.4819 292.453 75.2217 290.818 75.2217 288.802C75.2217 286.786 73.4819 285.151 71.3355 285.151",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3355 316.834C69.1891 316.834 67.4492 318.469 67.4492 320.485C67.4492 322.501 69.1891 324.136 71.3355 324.136C73.4819 324.136 75.2217 322.501 75.2217 320.485C75.2217 318.469 73.4819 316.834 71.3355 316.834",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3355 348.517C69.1891 348.517 67.4492 350.152 67.4492 352.168C67.4492 354.184 69.1891 355.819 71.3355 355.819C73.4819 355.819 75.2217 354.184 75.2217 352.168C75.2217 350.152 73.4819 348.517 71.3355 348.517",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3355 380.2C69.1891 380.2 67.4492 381.835 67.4492 383.851C67.4492 385.868 69.1891 387.502 71.3355 387.502C73.4819 387.502 75.2217 385.868 75.2217 383.851C75.2217 381.835 73.4819 380.2 71.3355 380.2",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3355 411.884C69.1891 411.884 67.4492 413.519 67.4492 415.535C67.4492 417.551 69.1891 419.186 71.3355 419.186C73.4819 419.186 75.2217 417.551 75.2217 415.535C75.2217 413.519 73.4819 411.884 71.3355 411.884",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3355 443.567C69.1891 443.567 67.4492 445.202 67.4492 447.218C67.4492 449.234 69.1891 450.869 71.3355 450.869C73.4819 450.869 75.2217 449.234 75.2217 447.218C75.2217 445.202 73.4819 443.567 71.3355 443.567",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3355 470.25C69.1891 470.25 67.4492 471.885 67.4492 473.901C67.4492 475.917 69.1891 477.552 71.3355 477.552C73.4819 477.552 75.2217 475.917 75.2217 473.901C75.2217 471.885 73.4819 470.25 71.3355 470.25",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3355 496.933C69.1891 496.933 67.4492 498.568 67.4492 500.584C67.4492 502.6 69.1891 504.235 71.3355 504.235C73.4819 504.235 75.2217 502.6 75.2217 500.584C75.2217 498.568 73.4819 496.933 71.3355 496.933",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.06 0.00244141C102.914 0.00244141 101.174 1.63694 101.174 3.65344C101.174 5.66944 102.914 7.30444 105.06 7.30444C107.206 7.30444 108.946 5.66944 108.946 3.65344C108.946 1.63694 107.206 0.00244141 105.06 0.00244141",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.06 31.6855C102.914 31.6855 101.174 33.32 101.174 35.3365C101.174 37.3525 102.914 38.9875 105.06 38.9875C107.206 38.9875 108.946 37.3525 108.946 35.3365C108.946 33.32 107.206 31.6855 105.06 31.6855",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.06 63.3687C102.914 63.3687 101.174 65.0032 101.174 67.0197C101.174 69.0362 102.914 70.6707 105.06 70.6707C107.206 70.6707 108.946 69.0362 108.946 67.0197C108.946 65.0032 107.206 63.3687 105.06 63.3687",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.06 95.0518C102.914 95.0518 101.174 96.6868 101.174 98.7028C101.174 100.719 102.914 102.354 105.06 102.354C107.206 102.354 108.946 100.719 108.946 98.7028C108.946 96.6868 107.206 95.0518 105.06 95.0518",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.06 126.735C102.914 126.735 101.174 128.37 101.174 130.386C101.174 132.402 102.914 134.037 105.06 134.037C107.206 134.037 108.946 132.402 108.946 130.386C108.946 128.37 107.206 126.735 105.06 126.735",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.06 158.418C102.914 158.418 101.174 160.053 101.174 162.069C101.174 164.086 102.914 165.72 105.06 165.72C107.206 165.72 108.946 164.086 108.946 162.069C108.946 160.053 107.206 158.418 105.06 158.418",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.06 190.101C102.914 190.101 101.174 191.736 101.174 193.752C101.174 195.769 102.914 197.403 105.06 197.403C107.206 197.403 108.946 195.769 108.946 193.752C108.946 191.736 107.206 190.101 105.06 190.101",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.06 221.784C102.914 221.784 101.174 223.419 101.174 225.435C101.174 227.452 102.914 229.086 105.06 229.086C107.206 229.086 108.946 227.452 108.946 225.435C108.946 223.419 107.206 221.784 105.06 221.784",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.06 253.468C102.914 253.468 101.174 255.103 101.174 257.119C101.174 259.135 102.914 260.77 105.06 260.77C107.206 260.77 108.946 259.135 108.946 257.119C108.946 255.103 107.206 253.468 105.06 253.468",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.06 285.151C102.914 285.151 101.174 286.786 101.174 288.802C101.174 290.818 102.914 292.453 105.06 292.453C107.206 292.453 108.946 290.818 108.946 288.802C108.946 286.786 107.206 285.151 105.06 285.151",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.06 316.834C102.914 316.834 101.174 318.469 101.174 320.485C101.174 322.501 102.914 324.136 105.06 324.136C107.206 324.136 108.946 322.501 108.946 320.485C108.946 318.469 107.206 316.834 105.06 316.834",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.06 348.517C102.914 348.517 101.174 350.152 101.174 352.168C101.174 354.184 102.914 355.819 105.06 355.819C107.206 355.819 108.946 354.184 108.946 352.168C108.946 350.152 107.206 348.517 105.06 348.517",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.06 380.2C102.914 380.2 101.174 381.835 101.174 383.851C101.174 385.868 102.914 387.502 105.06 387.502C107.206 387.502 108.946 385.868 108.946 383.851C108.946 381.835 107.206 380.2 105.06 380.2",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.06 411.884C102.914 411.884 101.174 413.519 101.174 415.535C101.174 417.551 102.914 419.186 105.06 419.186C107.206 419.186 108.946 417.551 108.946 415.535C108.946 413.519 107.206 411.884 105.06 411.884",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.06 443.567C102.914 443.567 101.174 445.202 101.174 447.218C101.174 449.234 102.914 450.869 105.06 450.869C107.206 450.869 108.946 449.234 108.946 447.218C108.946 445.202 107.206 443.567 105.06 443.567",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.06 470.25C102.914 470.25 101.174 471.885 101.174 473.901C101.174 475.917 102.914 477.552 105.06 477.552C107.206 477.552 108.946 475.917 108.946 473.901C108.946 471.885 107.206 470.25 105.06 470.25",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.06 496.933C102.914 496.933 101.174 498.568 101.174 500.584C101.174 502.6 102.914 504.235 105.06 504.235C107.206 504.235 108.946 502.6 108.946 500.584C108.946 498.568 107.206 496.933 105.06 496.933",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.785 0.00244141C136.638 0.00244141 134.898 1.63694 134.898 3.65344C134.898 5.66944 136.638 7.30444 138.785 7.30444C140.931 7.30444 142.671 5.66944 142.671 3.65344C142.671 1.63694 140.931 0.00244141 138.785 0.00244141",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.785 31.6855C136.638 31.6855 134.898 33.32 134.898 35.3365C134.898 37.3525 136.638 38.9875 138.785 38.9875C140.931 38.9875 142.671 37.3525 142.671 35.3365C142.671 33.32 140.931 31.6855 138.785 31.6855",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.785 63.3687C136.638 63.3687 134.898 65.0032 134.898 67.0197C134.898 69.0362 136.638 70.6707 138.785 70.6707C140.931 70.6707 142.671 69.0362 142.671 67.0197C142.671 65.0032 140.931 63.3687 138.785 63.3687",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.785 95.0518C136.638 95.0518 134.898 96.6868 134.898 98.7028C134.898 100.719 136.638 102.354 138.785 102.354C140.931 102.354 142.671 100.719 142.671 98.7028C142.671 96.6868 140.931 95.0518 138.785 95.0518",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.785 126.735C136.638 126.735 134.898 128.37 134.898 130.386C134.898 132.402 136.638 134.037 138.785 134.037C140.931 134.037 142.671 132.402 142.671 130.386C142.671 128.37 140.931 126.735 138.785 126.735",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.785 158.418C136.638 158.418 134.898 160.053 134.898 162.069C134.898 164.086 136.638 165.72 138.785 165.72C140.931 165.72 142.671 164.086 142.671 162.069C142.671 160.053 140.931 158.418 138.785 158.418",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.785 190.101C136.638 190.101 134.898 191.736 134.898 193.752C134.898 195.769 136.638 197.403 138.785 197.403C140.931 197.403 142.671 195.769 142.671 193.752C142.671 191.736 140.931 190.101 138.785 190.101",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.785 221.784C136.638 221.784 134.898 223.419 134.898 225.435C134.898 227.452 136.638 229.086 138.785 229.086C140.931 229.086 142.671 227.452 142.671 225.435C142.671 223.419 140.931 221.784 138.785 221.784",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.785 253.468C136.638 253.468 134.898 255.103 134.898 257.119C134.898 259.135 136.638 260.77 138.785 260.77C140.931 260.77 142.671 259.135 142.671 257.119C142.671 255.103 140.931 253.468 138.785 253.468",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.785 285.151C136.638 285.151 134.898 286.786 134.898 288.802C134.898 290.818 136.638 292.453 138.785 292.453C140.931 292.453 142.671 290.818 142.671 288.802C142.671 286.786 140.931 285.151 138.785 285.151",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.785 316.834C136.638 316.834 134.898 318.469 134.898 320.485C134.898 322.501 136.638 324.136 138.785 324.136C140.931 324.136 142.671 322.501 142.671 320.485C142.671 318.469 140.931 316.834 138.785 316.834",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.785 348.517C136.638 348.517 134.898 350.152 134.898 352.168C134.898 354.184 136.638 355.819 138.785 355.819C140.931 355.819 142.671 354.184 142.671 352.168C142.671 350.152 140.931 348.517 138.785 348.517",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.785 380.2C136.638 380.2 134.898 381.835 134.898 383.851C134.898 385.868 136.638 387.502 138.785 387.502C140.931 387.502 142.671 385.868 142.671 383.851C142.671 381.835 140.931 380.2 138.785 380.2",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.785 411.884C136.638 411.884 134.898 413.519 134.898 415.535C134.898 417.551 136.638 419.186 138.785 419.186C140.931 419.186 142.671 417.551 142.671 415.535C142.671 413.519 140.931 411.884 138.785 411.884",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.785 443.567C136.638 443.567 134.898 445.202 134.898 447.218C134.898 449.234 136.638 450.869 138.785 450.869C140.931 450.869 142.671 449.234 142.671 447.218C142.671 445.202 140.931 443.567 138.785 443.567",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.785 470.25C136.638 470.25 134.898 471.885 134.898 473.901C134.898 475.917 136.638 477.552 138.785 477.552C140.931 477.552 142.671 475.917 142.671 473.901C142.671 471.885 140.931 470.25 138.785 470.25",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.785 496.933C136.638 496.933 134.898 498.568 134.898 500.584C134.898 502.6 136.638 504.235 138.785 504.235C140.931 504.235 142.671 502.6 142.671 500.584C142.671 498.568 140.931 496.933 138.785 496.933",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.509 0.00244141C170.363 0.00244141 168.623 1.63694 168.623 3.65344C168.623 5.66944 170.363 7.30444 172.509 7.30444C174.656 7.30444 176.396 5.66944 176.396 3.65344C176.396 1.63694 174.656 0.00244141 172.509 0.00244141",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.509 31.6855C170.363 31.6855 168.623 33.32 168.623 35.3365C168.623 37.3525 170.363 38.9875 172.509 38.9875C174.656 38.9875 176.396 37.3525 176.396 35.3365C176.396 33.32 174.656 31.6855 172.509 31.6855",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.509 63.3687C170.363 63.3687 168.623 65.0032 168.623 67.0197C168.623 69.0362 170.363 70.6707 172.509 70.6707C174.656 70.6707 176.396 69.0362 176.396 67.0197C176.396 65.0032 174.656 63.3687 172.509 63.3687",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.509 95.0518C170.363 95.0518 168.623 96.6868 168.623 98.7028C168.623 100.719 170.363 102.354 172.509 102.354C174.656 102.354 176.396 100.719 176.396 98.7028C176.396 96.6868 174.656 95.0518 172.509 95.0518",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.509 126.735C170.363 126.735 168.623 128.37 168.623 130.386C168.623 132.402 170.363 134.037 172.509 134.037C174.656 134.037 176.396 132.402 176.396 130.386C176.396 128.37 174.656 126.735 172.509 126.735",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.509 158.418C170.363 158.418 168.623 160.053 168.623 162.069C168.623 164.086 170.363 165.72 172.509 165.72C174.656 165.72 176.396 164.086 176.396 162.069C176.396 160.053 174.656 158.418 172.509 158.418",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.509 190.101C170.363 190.101 168.623 191.736 168.623 193.752C168.623 195.769 170.363 197.403 172.509 197.403C174.656 197.403 176.396 195.769 176.396 193.752C176.396 191.736 174.656 190.101 172.509 190.101",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.509 221.784C170.363 221.784 168.623 223.419 168.623 225.435C168.623 227.452 170.363 229.086 172.509 229.086C174.656 229.086 176.396 227.452 176.396 225.435C176.396 223.419 174.656 221.784 172.509 221.784",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.509 253.468C170.363 253.468 168.623 255.103 168.623 257.119C168.623 259.135 170.363 260.77 172.509 260.77C174.656 260.77 176.396 259.135 176.396 257.119C176.396 255.103 174.656 253.468 172.509 253.468",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.509 285.151C170.363 285.151 168.623 286.786 168.623 288.802C168.623 290.818 170.363 292.453 172.509 292.453C174.656 292.453 176.396 290.818 176.396 288.802C176.396 286.786 174.656 285.151 172.509 285.151",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.509 316.834C170.363 316.834 168.623 318.469 168.623 320.485C168.623 322.501 170.363 324.136 172.509 324.136C174.656 324.136 176.396 322.501 176.396 320.485C176.396 318.469 174.656 316.834 172.509 316.834",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.509 348.517C170.363 348.517 168.623 350.152 168.623 352.168C168.623 354.184 170.363 355.819 172.509 355.819C174.656 355.819 176.396 354.184 176.396 352.168C176.396 350.152 174.656 348.517 172.509 348.517",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.509 380.2C170.363 380.2 168.623 381.835 168.623 383.851C168.623 385.868 170.363 387.502 172.509 387.502C174.656 387.502 176.396 385.868 176.396 383.851C176.396 381.835 174.656 380.2 172.509 380.2",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.509 411.884C170.363 411.884 168.623 413.519 168.623 415.535C168.623 417.551 170.363 419.186 172.509 419.186C174.656 419.186 176.396 417.551 176.396 415.535C176.396 413.519 174.656 411.884 172.509 411.884",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.509 443.567C170.363 443.567 168.623 445.202 168.623 447.218C168.623 449.234 170.363 450.869 172.509 450.869C174.656 450.869 176.396 449.234 176.396 447.218C176.396 445.202 174.656 443.567 172.509 443.567",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.509 470.25C170.363 470.25 168.623 471.885 168.623 473.901C168.623 475.917 170.363 477.552 172.509 477.552C174.656 477.552 176.396 475.917 176.396 473.901C176.396 471.885 174.656 470.25 172.509 470.25",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.509 496.933C170.363 496.933 168.623 498.568 168.623 500.584C168.623 502.6 170.363 504.235 172.509 504.235C174.656 504.235 176.396 502.6 176.396 500.584C176.396 498.568 174.656 496.933 172.509 496.933",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.234 0.00244141C204.087 0.00244141 202.348 1.63694 202.348 3.65344C202.348 5.66944 204.087 7.30444 206.234 7.30444C208.38 7.30444 210.12 5.66944 210.12 3.65344C210.12 1.63694 208.38 0.00244141 206.234 0.00244141",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.234 31.6855C204.087 31.6855 202.348 33.32 202.348 35.3365C202.348 37.3525 204.087 38.9875 206.234 38.9875C208.38 38.9875 210.12 37.3525 210.12 35.3365C210.12 33.32 208.38 31.6855 206.234 31.6855",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.234 63.3687C204.087 63.3687 202.348 65.0032 202.348 67.0197C202.348 69.0362 204.087 70.6707 206.234 70.6707C208.38 70.6707 210.12 69.0362 210.12 67.0197C210.12 65.0032 208.38 63.3687 206.234 63.3687",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.234 95.0518C204.087 95.0518 202.348 96.6868 202.348 98.7028C202.348 100.719 204.087 102.354 206.234 102.354C208.38 102.354 210.12 100.719 210.12 98.7028C210.12 96.6868 208.38 95.0518 206.234 95.0518",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.234 126.735C204.087 126.735 202.348 128.37 202.348 130.386C202.348 132.402 204.087 134.037 206.234 134.037C208.38 134.037 210.12 132.402 210.12 130.386C210.12 128.37 208.38 126.735 206.234 126.735",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.234 158.418C204.087 158.418 202.348 160.053 202.348 162.069C202.348 164.086 204.087 165.72 206.234 165.72C208.38 165.72 210.12 164.086 210.12 162.069C210.12 160.053 208.38 158.418 206.234 158.418",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.234 190.101C204.087 190.101 202.348 191.736 202.348 193.752C202.348 195.769 204.087 197.403 206.234 197.403C208.38 197.403 210.12 195.769 210.12 193.752C210.12 191.736 208.38 190.101 206.234 190.101",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.234 221.784C204.087 221.784 202.348 223.419 202.348 225.435C202.348 227.452 204.087 229.086 206.234 229.086C208.38 229.086 210.12 227.452 210.12 225.435C210.12 223.419 208.38 221.784 206.234 221.784",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.234 253.468C204.087 253.468 202.348 255.103 202.348 257.119C202.348 259.135 204.087 260.77 206.234 260.77C208.38 260.77 210.12 259.135 210.12 257.119C210.12 255.103 208.38 253.468 206.234 253.468",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.234 285.151C204.087 285.151 202.348 286.786 202.348 288.802C202.348 290.818 204.087 292.453 206.234 292.453C208.38 292.453 210.12 290.818 210.12 288.802C210.12 286.786 208.38 285.151 206.234 285.151",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.234 316.834C204.087 316.834 202.348 318.469 202.348 320.485C202.348 322.501 204.087 324.136 206.234 324.136C208.38 324.136 210.12 322.501 210.12 320.485C210.12 318.469 208.38 316.834 206.234 316.834",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.234 348.517C204.087 348.517 202.348 350.152 202.348 352.168C202.348 354.184 204.087 355.819 206.234 355.819C208.38 355.819 210.12 354.184 210.12 352.168C210.12 350.152 208.38 348.517 206.234 348.517",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.234 380.2C204.087 380.2 202.348 381.835 202.348 383.851C202.348 385.868 204.087 387.502 206.234 387.502C208.38 387.502 210.12 385.868 210.12 383.851C210.12 381.835 208.38 380.2 206.234 380.2",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.234 411.884C204.087 411.884 202.348 413.519 202.348 415.535C202.348 417.551 204.087 419.186 206.234 419.186C208.38 419.186 210.12 417.551 210.12 415.535C210.12 413.519 208.38 411.884 206.234 411.884",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.234 443.567C204.087 443.567 202.348 445.202 202.348 447.218C202.348 449.234 204.087 450.869 206.234 450.869C208.38 450.869 210.12 449.234 210.12 447.218C210.12 445.202 208.38 443.567 206.234 443.567",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.234 470.25C204.087 470.25 202.348 471.885 202.348 473.901C202.348 475.917 204.087 477.552 206.234 477.552C208.38 477.552 210.12 475.917 210.12 473.901C210.12 471.885 208.38 470.25 206.234 470.25",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.234 496.933C204.087 496.933 202.348 498.568 202.348 500.584C202.348 502.6 204.087 504.235 206.234 504.235C208.38 504.235 210.12 502.6 210.12 500.584C210.12 498.568 208.38 496.933 206.234 496.933",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.958 0.00244141C237.813 0.00244141 236.072 1.63694 236.072 3.65344C236.072 5.66944 237.813 7.30444 239.958 7.30444C242.105 7.30444 243.845 5.66944 243.845 3.65344C243.845 1.63694 242.105 0.00244141 239.958 0.00244141",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.958 31.6855C237.813 31.6855 236.072 33.32 236.072 35.3365C236.072 37.3525 237.813 38.9875 239.958 38.9875C242.105 38.9875 243.845 37.3525 243.845 35.3365C243.845 33.32 242.105 31.6855 239.958 31.6855",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.958 63.3687C237.813 63.3687 236.072 65.0032 236.072 67.0197C236.072 69.0362 237.813 70.6707 239.958 70.6707C242.105 70.6707 243.845 69.0362 243.845 67.0197C243.845 65.0032 242.105 63.3687 239.958 63.3687",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.958 95.0518C237.813 95.0518 236.072 96.6868 236.072 98.7028C236.072 100.719 237.813 102.354 239.958 102.354C242.105 102.354 243.845 100.719 243.845 98.7028C243.845 96.6868 242.105 95.0518 239.958 95.0518",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.958 126.735C237.813 126.735 236.072 128.37 236.072 130.386C236.072 132.402 237.813 134.037 239.958 134.037C242.105 134.037 243.845 132.402 243.845 130.386C243.845 128.37 242.105 126.735 239.958 126.735",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.958 158.418C237.813 158.418 236.072 160.053 236.072 162.069C236.072 164.086 237.813 165.72 239.958 165.72C242.105 165.72 243.845 164.086 243.845 162.069C243.845 160.053 242.105 158.418 239.958 158.418",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.958 190.101C237.813 190.101 236.072 191.736 236.072 193.752C236.072 195.769 237.813 197.403 239.958 197.403C242.105 197.403 243.845 195.769 243.845 193.752C243.845 191.736 242.105 190.101 239.958 190.101",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.958 221.784C237.813 221.784 236.072 223.419 236.072 225.435C236.072 227.452 237.813 229.086 239.958 229.086C242.105 229.086 243.845 227.452 243.845 225.435C243.845 223.419 242.105 221.784 239.958 221.784",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.958 253.468C237.813 253.468 236.072 255.103 236.072 257.119C236.072 259.135 237.813 260.77 239.958 260.77C242.105 260.77 243.845 259.135 243.845 257.119C243.845 255.103 242.105 253.468 239.958 253.468",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.958 285.151C237.813 285.151 236.072 286.786 236.072 288.802C236.072 290.818 237.813 292.453 239.958 292.453C242.105 292.453 243.845 290.818 243.845 288.802C243.845 286.786 242.105 285.151 239.958 285.151",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.958 316.834C237.813 316.834 236.072 318.469 236.072 320.485C236.072 322.501 237.813 324.136 239.958 324.136C242.105 324.136 243.845 322.501 243.845 320.485C243.845 318.469 242.105 316.834 239.958 316.834",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.958 348.517C237.813 348.517 236.072 350.152 236.072 352.168C236.072 354.184 237.813 355.819 239.958 355.819C242.105 355.819 243.845 354.184 243.845 352.168C243.845 350.152 242.105 348.517 239.958 348.517",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.958 380.2C237.813 380.2 236.072 381.835 236.072 383.851C236.072 385.868 237.813 387.502 239.958 387.502C242.105 387.502 243.845 385.868 243.845 383.851C243.845 381.835 242.105 380.2 239.958 380.2",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.958 411.884C237.813 411.884 236.072 413.519 236.072 415.535C236.072 417.551 237.813 419.186 239.958 419.186C242.105 419.186 243.845 417.551 243.845 415.535C243.845 413.519 242.105 411.884 239.958 411.884",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.958 443.567C237.813 443.567 236.072 445.202 236.072 447.218C236.072 449.234 237.813 450.869 239.958 450.869C242.105 450.869 243.845 449.234 243.845 447.218C243.845 445.202 242.105 443.567 239.958 443.567",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.958 470.25C237.813 470.25 236.072 471.885 236.072 473.901C236.072 475.917 237.813 477.552 239.958 477.552C242.105 477.552 243.845 475.917 243.845 473.901C243.845 471.885 242.105 470.25 239.958 470.25",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.958 496.933C237.813 496.933 236.072 498.568 236.072 500.584C236.072 502.6 237.813 504.235 239.958 504.235C242.105 504.235 243.845 502.6 243.845 500.584C243.845 498.568 242.105 496.933 239.958 496.933",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.683 0.00244141C271.537 0.00244141 269.797 1.63694 269.797 3.65344C269.797 5.66944 271.537 7.30444 273.683 7.30444C275.829 7.30444 277.569 5.66944 277.569 3.65344C277.569 1.63694 275.829 0.00244141 273.683 0.00244141",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.683 31.6855C271.537 31.6855 269.797 33.32 269.797 35.3365C269.797 37.3525 271.537 38.9875 273.683 38.9875C275.829 38.9875 277.569 37.3525 277.569 35.3365C277.569 33.32 275.829 31.6855 273.683 31.6855",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.683 63.3687C271.537 63.3687 269.797 65.0032 269.797 67.0197C269.797 69.0362 271.537 70.6707 273.683 70.6707C275.829 70.6707 277.569 69.0362 277.569 67.0197C277.569 65.0032 275.829 63.3687 273.683 63.3687",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.683 95.0518C271.537 95.0518 269.797 96.6868 269.797 98.7028C269.797 100.719 271.537 102.354 273.683 102.354C275.829 102.354 277.569 100.719 277.569 98.7028C277.569 96.6868 275.829 95.0518 273.683 95.0518",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.683 126.735C271.537 126.735 269.797 128.37 269.797 130.386C269.797 132.402 271.537 134.037 273.683 134.037C275.829 134.037 277.569 132.402 277.569 130.386C277.569 128.37 275.829 126.735 273.683 126.735",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.683 158.418C271.537 158.418 269.797 160.053 269.797 162.069C269.797 164.086 271.537 165.72 273.683 165.72C275.829 165.72 277.569 164.086 277.569 162.069C277.569 160.053 275.829 158.418 273.683 158.418",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.683 190.101C271.537 190.101 269.797 191.736 269.797 193.752C269.797 195.769 271.537 197.403 273.683 197.403C275.829 197.403 277.569 195.769 277.569 193.752C277.569 191.736 275.829 190.101 273.683 190.101",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.683 221.784C271.537 221.784 269.797 223.419 269.797 225.435C269.797 227.452 271.537 229.086 273.683 229.086C275.829 229.086 277.569 227.452 277.569 225.435C277.569 223.419 275.829 221.784 273.683 221.784",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.683 253.468C271.537 253.468 269.797 255.103 269.797 257.119C269.797 259.135 271.537 260.77 273.683 260.77C275.829 260.77 277.569 259.135 277.569 257.119C277.569 255.103 275.829 253.468 273.683 253.468",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.683 285.151C271.537 285.151 269.797 286.786 269.797 288.802C269.797 290.818 271.537 292.453 273.683 292.453C275.829 292.453 277.569 290.818 277.569 288.802C277.569 286.786 275.829 285.151 273.683 285.151",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.683 316.834C271.537 316.834 269.797 318.469 269.797 320.485C269.797 322.501 271.537 324.136 273.683 324.136C275.829 324.136 277.569 322.501 277.569 320.485C277.569 318.469 275.829 316.834 273.683 316.834",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.683 348.517C271.537 348.517 269.797 350.152 269.797 352.168C269.797 354.184 271.537 355.819 273.683 355.819C275.829 355.819 277.569 354.184 277.569 352.168C277.569 350.152 275.829 348.517 273.683 348.517",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.683 380.2C271.537 380.2 269.797 381.835 269.797 383.851C269.797 385.868 271.537 387.502 273.683 387.502C275.829 387.502 277.569 385.868 277.569 383.851C277.569 381.835 275.829 380.2 273.683 380.2",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.683 411.884C271.537 411.884 269.797 413.519 269.797 415.535C269.797 417.551 271.537 419.186 273.683 419.186C275.829 419.186 277.569 417.551 277.569 415.535C277.569 413.519 275.829 411.884 273.683 411.884",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.683 443.567C271.537 443.567 269.797 445.202 269.797 447.218C269.797 449.234 271.537 450.869 273.683 450.869C275.829 450.869 277.569 449.234 277.569 447.218C277.569 445.202 275.829 443.567 273.683 443.567",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.683 470.25C271.537 470.25 269.797 471.885 269.797 473.901C269.797 475.917 271.537 477.552 273.683 477.552C275.829 477.552 277.569 475.917 277.569 473.901C277.569 471.885 275.829 470.25 273.683 470.25",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.683 496.933C271.537 496.933 269.797 498.568 269.797 500.584C269.797 502.6 271.537 504.235 273.683 504.235C275.829 504.235 277.569 502.6 277.569 500.584C277.569 498.568 275.829 496.933 273.683 496.933",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.407 0.00244141C305.262 0.00244141 303.521 1.63694 303.521 3.65344C303.521 5.66944 305.262 7.30444 307.407 7.30444C309.554 7.30444 311.294 5.66944 311.294 3.65344C311.294 1.63694 309.554 0.00244141 307.407 0.00244141",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.407 31.6855C305.262 31.6855 303.521 33.32 303.521 35.3365C303.521 37.3525 305.262 38.9875 307.407 38.9875C309.554 38.9875 311.294 37.3525 311.294 35.3365C311.294 33.32 309.554 31.6855 307.407 31.6855",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.407 63.3687C305.262 63.3687 303.521 65.0032 303.521 67.0197C303.521 69.0362 305.262 70.6707 307.407 70.6707C309.554 70.6707 311.294 69.0362 311.294 67.0197C311.294 65.0032 309.554 63.3687 307.407 63.3687",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.407 95.0518C305.262 95.0518 303.521 96.6868 303.521 98.7028C303.521 100.719 305.262 102.354 307.407 102.354C309.554 102.354 311.294 100.719 311.294 98.7028C311.294 96.6868 309.554 95.0518 307.407 95.0518",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.407 126.735C305.262 126.735 303.521 128.37 303.521 130.386C303.521 132.402 305.262 134.037 307.407 134.037C309.554 134.037 311.294 132.402 311.294 130.386C311.294 128.37 309.554 126.735 307.407 126.735",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.407 158.418C305.262 158.418 303.521 160.053 303.521 162.069C303.521 164.086 305.262 165.72 307.407 165.72C309.554 165.72 311.294 164.086 311.294 162.069C311.294 160.053 309.554 158.418 307.407 158.418",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.407 190.101C305.262 190.101 303.521 191.736 303.521 193.752C303.521 195.769 305.262 197.403 307.407 197.403C309.554 197.403 311.294 195.769 311.294 193.752C311.294 191.736 309.554 190.101 307.407 190.101",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.407 221.784C305.262 221.784 303.521 223.419 303.521 225.435C303.521 227.452 305.262 229.086 307.407 229.086C309.554 229.086 311.294 227.452 311.294 225.435C311.294 223.419 309.554 221.784 307.407 221.784",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.407 253.468C305.262 253.468 303.521 255.103 303.521 257.119C303.521 259.135 305.262 260.77 307.407 260.77C309.554 260.77 311.294 259.135 311.294 257.119C311.294 255.103 309.554 253.468 307.407 253.468",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.407 285.151C305.262 285.151 303.521 286.786 303.521 288.802C303.521 290.818 305.262 292.453 307.407 292.453C309.554 292.453 311.294 290.818 311.294 288.802C311.294 286.786 309.554 285.151 307.407 285.151",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.407 316.834C305.262 316.834 303.521 318.469 303.521 320.485C303.521 322.501 305.262 324.136 307.407 324.136C309.554 324.136 311.294 322.501 311.294 320.485C311.294 318.469 309.554 316.834 307.407 316.834",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.407 348.517C305.262 348.517 303.521 350.152 303.521 352.168C303.521 354.184 305.262 355.819 307.407 355.819C309.554 355.819 311.294 354.184 311.294 352.168C311.294 350.152 309.554 348.517 307.407 348.517",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.407 380.2C305.262 380.2 303.521 381.835 303.521 383.851C303.521 385.868 305.262 387.502 307.407 387.502C309.554 387.502 311.294 385.868 311.294 383.851C311.294 381.835 309.554 380.2 307.407 380.2",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.407 411.884C305.262 411.884 303.521 413.519 303.521 415.535C303.521 417.551 305.262 419.186 307.407 419.186C309.554 419.186 311.294 417.551 311.294 415.535C311.294 413.519 309.554 411.884 307.407 411.884",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.407 443.567C305.262 443.567 303.521 445.202 303.521 447.218C303.521 449.234 305.262 450.869 307.407 450.869C309.554 450.869 311.294 449.234 311.294 447.218C311.294 445.202 309.554 443.567 307.407 443.567",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.407 470.25C305.262 470.25 303.521 471.885 303.521 473.901C303.521 475.917 305.262 477.552 307.407 477.552C309.554 477.552 311.294 475.917 311.294 473.901C311.294 471.885 309.554 470.25 307.407 470.25",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.407 496.933C305.262 496.933 303.521 498.568 303.521 500.584C303.521 502.6 305.262 504.235 307.407 504.235C309.554 504.235 311.294 502.6 311.294 500.584C311.294 498.568 309.554 496.933 307.407 496.933",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.133 0.00244141C338.986 0.00244141 337.246 1.63694 337.246 3.65344C337.246 5.66944 338.986 7.30444 341.133 7.30444C343.278 7.30444 345.019 5.66944 345.019 3.65344C345.019 1.63694 343.278 0.00244141 341.133 0.00244141",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.133 31.6855C338.986 31.6855 337.246 33.32 337.246 35.3365C337.246 37.3525 338.986 38.9875 341.133 38.9875C343.278 38.9875 345.019 37.3525 345.019 35.3365C345.019 33.32 343.278 31.6855 341.133 31.6855",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.133 63.3687C338.986 63.3687 337.246 65.0032 337.246 67.0197C337.246 69.0362 338.986 70.6707 341.133 70.6707C343.278 70.6707 345.019 69.0362 345.019 67.0197C345.019 65.0032 343.278 63.3687 341.133 63.3687",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.133 95.0518C338.986 95.0518 337.246 96.6868 337.246 98.7028C337.246 100.719 338.986 102.354 341.133 102.354C343.278 102.354 345.019 100.719 345.019 98.7028C345.019 96.6868 343.278 95.0518 341.133 95.0518",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.133 126.735C338.986 126.735 337.246 128.37 337.246 130.386C337.246 132.402 338.986 134.037 341.133 134.037C343.278 134.037 345.019 132.402 345.019 130.386C345.019 128.37 343.278 126.735 341.133 126.735",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.133 158.418C338.986 158.418 337.246 160.053 337.246 162.069C337.246 164.086 338.986 165.72 341.133 165.72C343.278 165.72 345.019 164.086 345.019 162.069C345.019 160.053 343.278 158.418 341.133 158.418",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.133 190.101C338.986 190.101 337.246 191.736 337.246 193.752C337.246 195.769 338.986 197.403 341.133 197.403C343.278 197.403 345.019 195.769 345.019 193.752C345.019 191.736 343.278 190.101 341.133 190.101",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.133 221.784C338.986 221.784 337.246 223.419 337.246 225.435C337.246 227.452 338.986 229.086 341.133 229.086C343.278 229.086 345.019 227.452 345.019 225.435C345.019 223.419 343.278 221.784 341.133 221.784",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.133 253.468C338.986 253.468 337.246 255.103 337.246 257.119C337.246 259.135 338.986 260.77 341.133 260.77C343.278 260.77 345.019 259.135 345.019 257.119C345.019 255.103 343.278 253.468 341.133 253.468",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.133 285.151C338.986 285.151 337.246 286.786 337.246 288.802C337.246 290.818 338.986 292.453 341.133 292.453C343.278 292.453 345.019 290.818 345.019 288.802C345.019 286.786 343.278 285.151 341.133 285.151",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.133 316.834C338.986 316.834 337.246 318.469 337.246 320.485C337.246 322.501 338.986 324.136 341.133 324.136C343.278 324.136 345.019 322.501 345.019 320.485C345.019 318.469 343.278 316.834 341.133 316.834",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.133 348.517C338.986 348.517 337.246 350.152 337.246 352.168C337.246 354.184 338.986 355.819 341.133 355.819C343.278 355.819 345.019 354.184 345.019 352.168C345.019 350.152 343.278 348.517 341.133 348.517",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.133 380.2C338.986 380.2 337.246 381.835 337.246 383.851C337.246 385.868 338.986 387.502 341.133 387.502C343.278 387.502 345.019 385.868 345.019 383.851C345.019 381.835 343.278 380.2 341.133 380.2",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.133 411.884C338.986 411.884 337.246 413.519 337.246 415.535C337.246 417.551 338.986 419.186 341.133 419.186C343.278 419.186 345.019 417.551 345.019 415.535C345.019 413.519 343.278 411.884 341.133 411.884",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.133 443.567C338.986 443.567 337.246 445.202 337.246 447.218C337.246 449.234 338.986 450.869 341.133 450.869C343.278 450.869 345.019 449.234 345.019 447.218C345.019 445.202 343.278 443.567 341.133 443.567",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.133 470.25C338.986 470.25 337.246 471.885 337.246 473.901C337.246 475.917 338.986 477.552 341.133 477.552C343.278 477.552 345.019 475.917 345.019 473.901C345.019 471.885 343.278 470.25 341.133 470.25",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.133 496.933C338.986 496.933 337.246 498.568 337.246 500.584C337.246 502.6 338.986 504.235 341.133 504.235C343.278 504.235 345.019 502.6 345.019 500.584C345.019 498.568 343.278 496.933 341.133 496.933",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.857 0.00244141C372.711 0.00244141 370.97 1.63694 370.97 3.65344C370.97 5.66944 372.711 7.30444 374.857 7.30444C377.003 7.30444 378.743 5.66944 378.743 3.65344C378.743 1.63694 377.003 0.00244141 374.857 0.00244141",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.857 31.6855C372.711 31.6855 370.97 33.32 370.97 35.3365C370.97 37.3525 372.711 38.9875 374.857 38.9875C377.003 38.9875 378.743 37.3525 378.743 35.3365C378.743 33.32 377.003 31.6855 374.857 31.6855",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.857 63.3687C372.711 63.3687 370.97 65.0032 370.97 67.0197C370.97 69.0362 372.711 70.6707 374.857 70.6707C377.003 70.6707 378.743 69.0362 378.743 67.0197C378.743 65.0032 377.003 63.3687 374.857 63.3687",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.857 95.0518C372.711 95.0518 370.97 96.6868 370.97 98.7028C370.97 100.719 372.711 102.354 374.857 102.354C377.003 102.354 378.743 100.719 378.743 98.7028C378.743 96.6868 377.003 95.0518 374.857 95.0518",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.857 126.735C372.711 126.735 370.97 128.37 370.97 130.386C370.97 132.402 372.711 134.037 374.857 134.037C377.003 134.037 378.743 132.402 378.743 130.386C378.743 128.37 377.003 126.735 374.857 126.735",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.857 158.418C372.711 158.418 370.97 160.053 370.97 162.069C370.97 164.086 372.711 165.72 374.857 165.72C377.003 165.72 378.743 164.086 378.743 162.069C378.743 160.053 377.003 158.418 374.857 158.418",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.857 190.101C372.711 190.101 370.97 191.736 370.97 193.752C370.97 195.769 372.711 197.403 374.857 197.403C377.003 197.403 378.743 195.769 378.743 193.752C378.743 191.736 377.003 190.101 374.857 190.101",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.857 221.784C372.711 221.784 370.97 223.419 370.97 225.435C370.97 227.452 372.711 229.086 374.857 229.086C377.003 229.086 378.743 227.452 378.743 225.435C378.743 223.419 377.003 221.784 374.857 221.784",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.857 253.468C372.711 253.468 370.97 255.103 370.97 257.119C370.97 259.135 372.711 260.77 374.857 260.77C377.003 260.77 378.743 259.135 378.743 257.119C378.743 255.103 377.003 253.468 374.857 253.468",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.857 285.151C372.711 285.151 370.97 286.786 370.97 288.802C370.97 290.818 372.711 292.453 374.857 292.453C377.003 292.453 378.743 290.818 378.743 288.802C378.743 286.786 377.003 285.151 374.857 285.151",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.857 316.834C372.711 316.834 370.97 318.469 370.97 320.485C370.97 322.501 372.711 324.136 374.857 324.136C377.003 324.136 378.743 322.501 378.743 320.485C378.743 318.469 377.003 316.834 374.857 316.834",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.857 348.517C372.711 348.517 370.97 350.152 370.97 352.168C370.97 354.184 372.711 355.819 374.857 355.819C377.003 355.819 378.743 354.184 378.743 352.168C378.743 350.152 377.003 348.517 374.857 348.517",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.857 380.2C372.711 380.2 370.97 381.835 370.97 383.851C370.97 385.868 372.711 387.502 374.857 387.502C377.003 387.502 378.743 385.868 378.743 383.851C378.743 381.835 377.003 380.2 374.857 380.2",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.857 411.884C372.711 411.884 370.97 413.519 370.97 415.535C370.97 417.551 372.711 419.186 374.857 419.186C377.003 419.186 378.743 417.551 378.743 415.535C378.743 413.519 377.003 411.884 374.857 411.884",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.857 443.567C372.711 443.567 370.97 445.202 370.97 447.218C370.97 449.234 372.711 450.869 374.857 450.869C377.003 450.869 378.743 449.234 378.743 447.218C378.743 445.202 377.003 443.567 374.857 443.567",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.857 470.25C372.711 470.25 370.97 471.885 370.97 473.901C370.97 475.917 372.711 477.552 374.857 477.552C377.003 477.552 378.743 475.917 378.743 473.901C378.743 471.885 377.003 470.25 374.857 470.25",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.857 496.933C372.711 496.933 370.97 498.568 370.97 500.584C370.97 502.6 372.711 504.235 374.857 504.235C377.003 504.235 378.743 502.6 378.743 500.584C378.743 498.568 377.003 496.933 374.857 496.933",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.582 0.00244141C406.435 0.00244141 404.695 1.63694 404.695 3.65344C404.695 5.66944 406.435 7.30444 408.582 7.30444C410.728 7.30444 412.468 5.66944 412.468 3.65344C412.468 1.63694 410.728 0.00244141 408.582 0.00244141",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.582 31.6855C406.435 31.6855 404.695 33.32 404.695 35.3365C404.695 37.3525 406.435 38.9875 408.582 38.9875C410.728 38.9875 412.468 37.3525 412.468 35.3365C412.468 33.32 410.728 31.6855 408.582 31.6855",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.582 63.3687C406.435 63.3687 404.695 65.0032 404.695 67.0197C404.695 69.0362 406.435 70.6707 408.582 70.6707C410.728 70.6707 412.468 69.0362 412.468 67.0197C412.468 65.0032 410.728 63.3687 408.582 63.3687",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.582 95.0518C406.435 95.0518 404.695 96.6868 404.695 98.7028C404.695 100.719 406.435 102.354 408.582 102.354C410.728 102.354 412.468 100.719 412.468 98.7028C412.468 96.6868 410.728 95.0518 408.582 95.0518",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.582 126.735C406.435 126.735 404.695 128.37 404.695 130.386C404.695 132.402 406.435 134.037 408.582 134.037C410.728 134.037 412.468 132.402 412.468 130.386C412.468 128.37 410.728 126.735 408.582 126.735",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.582 158.418C406.435 158.418 404.695 160.053 404.695 162.069C404.695 164.086 406.435 165.72 408.582 165.72C410.728 165.72 412.468 164.086 412.468 162.069C412.468 160.053 410.728 158.418 408.582 158.418",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.582 190.101C406.435 190.101 404.695 191.736 404.695 193.752C404.695 195.769 406.435 197.403 408.582 197.403C410.728 197.403 412.468 195.769 412.468 193.752C412.468 191.736 410.728 190.101 408.582 190.101",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.582 221.784C406.435 221.784 404.695 223.419 404.695 225.435C404.695 227.452 406.435 229.086 408.582 229.086C410.728 229.086 412.468 227.452 412.468 225.435C412.468 223.419 410.728 221.784 408.582 221.784",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.582 253.468C406.435 253.468 404.695 255.103 404.695 257.119C404.695 259.135 406.435 260.77 408.582 260.77C410.728 260.77 412.468 259.135 412.468 257.119C412.468 255.103 410.728 253.468 408.582 253.468",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.582 285.151C406.435 285.151 404.695 286.786 404.695 288.802C404.695 290.818 406.435 292.453 408.582 292.453C410.728 292.453 412.468 290.818 412.468 288.802C412.468 286.786 410.728 285.151 408.582 285.151",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.582 316.834C406.435 316.834 404.695 318.469 404.695 320.485C404.695 322.501 406.435 324.136 408.582 324.136C410.728 324.136 412.468 322.501 412.468 320.485C412.468 318.469 410.728 316.834 408.582 316.834",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.582 348.517C406.435 348.517 404.695 350.152 404.695 352.168C404.695 354.184 406.435 355.819 408.582 355.819C410.728 355.819 412.468 354.184 412.468 352.168C412.468 350.152 410.728 348.517 408.582 348.517",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.582 380.2C406.435 380.2 404.695 381.835 404.695 383.851C404.695 385.868 406.435 387.502 408.582 387.502C410.728 387.502 412.468 385.868 412.468 383.851C412.468 381.835 410.728 380.2 408.582 380.2",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.582 411.884C406.435 411.884 404.695 413.519 404.695 415.535C404.695 417.551 406.435 419.186 408.582 419.186C410.728 419.186 412.468 417.551 412.468 415.535C412.468 413.519 410.728 411.884 408.582 411.884",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.582 443.567C406.435 443.567 404.695 445.202 404.695 447.218C404.695 449.234 406.435 450.869 408.582 450.869C410.728 450.869 412.468 449.234 412.468 447.218C412.468 445.202 410.728 443.567 408.582 443.567",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.582 470.25C406.435 470.25 404.695 471.885 404.695 473.901C404.695 475.917 406.435 477.552 408.582 477.552C410.728 477.552 412.468 475.917 412.468 473.901C412.468 471.885 410.728 470.25 408.582 470.25",
    fill: "#A6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.582 496.933C406.435 496.933 404.695 498.568 404.695 500.584C404.695 502.6 406.435 504.235 408.582 504.235C410.728 504.235 412.468 502.6 412.468 500.584C412.468 498.568 410.728 496.933 408.582 496.933",
    fill: "#A6BCFA"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.80336227c9e5a108b02b92d55c605729.svg";
export { ForwardRef as ReactComponent };